export default {  
  setErrors: (state, error) => {
    state.errors = { ...state.errors, ...error };
  },
  setConfiguration: (state, configuration) => {
    state.configuration = configuration;
  },  
  setLoading: (state, loading) => {
    state.loading = loading;
  },
  setDevelopmentFileList: (state, payload) => {
    state.developmentFileList = payload;
  }
};
